import { useMethods } from 'react-use';

export enum SelectScorecardDialogStates {
  SelectScorecards = 'SELECT_SCORECARDS',
  CreateScorecard = 'CREATE_SCORECARD',
}

export interface ExerciseCreatorStates {
  selectScorecardDialogState: SelectScorecardDialogStates | null;
}

const initialState: ExerciseCreatorStates = {
  selectScorecardDialogState: null,
};

function createMethods(state: ExerciseCreatorStates) {
  return {
    setScorecardDialogState(dialogState: SelectScorecardDialogStates | null) {
      return { ...state, selectScorecardDialogState: dialogState };
    },
  };
}

function useExerciseScorecardManager() {
  const [state, methods] = useMethods(createMethods, initialState);

  return {
    state,
    methods,
  };
}

export default useExerciseScorecardManager;
